import React, { useContext, useEffect } from "react";
import { connect } from "react-redux";
import * as deviceService from "../devices/deviceService";
import { debug, sortObjectsByAlphabet } from "../utils";
import * as urlService from "../view/urlService";
import { useHistory } from "react-router-dom";
import { TableContext } from "../index";
import { getFilters } from "../view/urlService";

function DeviceTypeField({ deviceTypes, selectType, selectedType }) {

    const history = useHistory();
    const { config, setConfig } = useContext(TableContext);


    useEffect(() => {
        const loadPageData = async () => {
            const pageFilters = getFilters(true);
            const { deviceTypes: deviceTypesList } = await deviceService.loadAssignedDeviceTargetTypes();
            if (deviceTypesList && Array.isArray(deviceTypesList) && deviceTypesList.length) {
                if (pageFilters.deviceType) {
                    const preselected = deviceTypesList.find(deviceType => deviceType.name === pageFilters.deviceType);
                    if (preselected) {
                        selectType(preselected.id);
                    }
                }
            }
            setConfig({ ...config, filtersLoading: false })
        }
        loadPageData();
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [history.location])

    const onChange = (deviceTypeId) => {

        if (deviceTypes) {
            selectType(deviceTypeId);

            if (deviceTypeId === 'all') {
                history.push({
                    pathname: history.pathname,
                    search: urlService.removeFilter('deviceType')
                })
                return;
            }

            const deviceType = deviceTypes.find(type => type.id === Number(deviceTypeId));

            if (!deviceType) {
                return;
            }

            history.push({
                pathname: history.pathname,
                search: urlService.replaceFilters('deviceType', deviceType.name)
            })
        }
    }

    const deviceTypeCopy = sortObjectsByAlphabet(deviceTypes, 'name');

    return (
        <div className="form-group">
            <div className="oct_form-group">
                <label htmlFor="deviceType">device type</label>
                <select className="form-control oct_select" id="deviceType" value={selectedType}
                    onChange={event => onChange(event.target.value)}>
                    <option value={'all'}>All</option>
                    {
                        deviceTypeCopy &&
                        deviceTypeCopy.map((device, index) => <option key={index} value={device.id}>{device.name}</option>)
                    }
                </select>
            </div>
        </div>
    );
}

function mapStateToProps(state) {
    debug("DeviceTypeField mapStateToProps", state);
    const recentViolationsPage = state.recentViolationsPage;
    return {
        deviceTypes: recentViolationsPage.deviceTypes
    };
}

export default connect(mapStateToProps)(DeviceTypeField);
